import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { CheckIcon } from '../../../icons/CheckIcon';
import { CloseIcon } from '../../../icons/CloseIcon';
import { CircularButton } from '../../CircularButton/CircularButton';
import styles from './SuccessToast.module.css';

export type SuccessToastProps = {
  className?: string;
  description?: string;
  id: number | string;
  onClose: () => void;
  title: string;
};

export const SuccessToast: FunctionComponent<SuccessToastProps> = ({
  className,
  description,
  id,
  onClose,
  title,
}) => {
  return (
    <div className={cx(styles.root, className)} key={id}>
      <div className={styles.container}>
        <CheckIcon />
        <div className={styles.textContent}>
          <span className={styles.title}>{title}</span>
          <span>{description}</span>
        </div>
      </div>
      <div>
        <CircularButton className={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </CircularButton>
      </div>
    </div>
  );
};
